<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-alert-triangle-fill`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26.012 4.546a4 4 0 011.44 1.44l17.996 30.03a4 4 0 01-3.455 6.015H6a4 4 0 01-3.455-6.015l17.997-30.03a4 4 0 015.47-1.44zM24.747 32.03c.76 0 1.375.616 1.375 1.375v1.375c0 .76-.616 1.375-1.375 1.375h-1.375c-.76 0-1.375-.615-1.375-1.375v-1.375c0-.759.616-1.375 1.375-1.375h1.375zm1.258-15.002a1 1 0 00-1-1h-2a1 1 0 00-1 1V29.03a1 1 0 001 1h2a1 1 0 001-1v-12z"/></svg>
</template>
<script>

export default {
  name: 'IconAlertTriangleFill',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
